import React from 'react'
import { PaginaType } from 'utils/types'
import { useTrans } from 'hooks'
import { WContainer } from 'components/atoms'
import {
  Page,
  MyUnsubscribeFormCard
} from 'components/organisms'
import styles from './UnsubscribeTemplate.module.sass'

interface IUnsub{
    unsub: {
        name: string
        optinName: string
        image: string
        value: boolean
    }
}

interface Props {
  pagina: PaginaType
  unsubs: IUnsub[]
  token: string
}

const UnsubscribeTemplate = ({ pagina, unsubs, token }: Props) => {
  const t = useTrans()

  return (
    <Page pagina={pagina}>
      <WContainer variant="xs">
        <div className={styles.main}>
          <h1 className={styles.title}>{t('Non vuoi più ricevere le comunicazioni Danone?')}</h1>
          <div className={styles.description}>
            <p>{t('Seleziona il brand da cui non vuoi più ricervere le newsletter.')}</p>
            <p>{t('Qui trovi tutti i Brand di Danone da cui potresti ricevere comunicazioni promozionali e pubblicitarie.')}</p>
          </div>
        </div>
        <MyUnsubscribeFormCard unsubs={unsubs} token={token}/>
      </WContainer>
    </Page>
  )
}

export default UnsubscribeTemplate
